import {createContext} from 'react'

export const DegreeContext = createContext({
  modalOpen: false,
  setModalOpen: () => {
  },
  gridRowCount: 0,
  setGridRowCount: () => {
  },
  gridCurrentPage: 1,
  setGridCurrentPage: () => {
  },
  degree: {
    id: null,
    title: null,
    description: null,
    status: "",
  },
  setDegree: () => {
  },
  lastDataRefresh: Date.now(),
  setLastDataRefresh: () => {
  },
})